import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { ConsultorioAtualizacaoService } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-atualizacao.service';
import { ConsultorioAnotacaoCreateRequest, ConsultorioAtualizacaoRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-atualizacao.model';
import { HttpContext } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
/** Fachada de anotações do consultório privado. */
export class ConsultorioAnotacoesFeatureService extends CustomService {
    private readonly core = inject(ConsultorioAtualizacaoService);

    buscar(params: Pessoa & { idConsultorio: number }): Observable<ConsultorioAtualizacaoRequest[]> {
        return this.core.buscarAnotacoes(params).pipe(catchError(this.handleError));
    }

    inserirAnotacao(pessoa: Pessoa, body: ConsultorioAnotacaoCreateRequest, context?: HttpContext): Observable<void> {
        return this.core.inserirAnotacao(pessoa, body, context).pipe(catchError(this.handleError));
    }
}
